import * as React from "react";
import { Stack, Avatar, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import InputControl from "../../../shared/components/InputControl";
import SimpleReactValidator from "simple-react-validator";
import { successMessage } from "../../../utils";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";


export const ConnectTandaDialog = ({ onChange, state, handleUpdate, redirectURL }) => {
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const onSubmit = () => {
    if (validator.current.allValid()) {
      handleUpdate();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  return (
    <Stack gap="16px" mt="16px">
      <InputControl
        label="Application ID"
        name="application_id"
        type="text"
        value={state.inputData.application_id || ""}
        onChange={onChange}
        required={true}
        error={validator.current.message(
          "Application ID",
          state.inputData.application_id,
          "required"
        )}
        helperText={validator.current.message(
          "Application ID",
          state.inputData.application_id,
          "required"
        )}
      />

      <InputControl
        label="Client Secret"
        name="client_secret"
        type="text"
        value={state.inputData.client_secret || ""}
        onChange={onChange}
        required={true}
        error={validator.current.message(
          "Client Secret",
          state.inputData.client_secret,
          "required"
        )}
        helperText={validator.current.message(
          "Client Secret",
          state.inputData.client_secret,
          "required"
        )}
      />
      <Stack
        sx={
          {
            flexDirection: "row",
            gap: "10px",
            alignItems: "center",
          }
        }
      >

        <InputControl
          label="Redirect URI"
          name="redirect_uri"
          type="text"
          value={redirectURL}
          required={true}
          disabled={true}

        />
        <Avatar
          sx={{
            height: 46,
            width: 46,
            bgcolor: " rgba(0, 0, 0, 0.03)",
            cursor: "pointer",
            "&:hover": {
              bgcolor: "rgba(0,0,0, 0.08)",
            },
          }}
          variant="rounded"
          onClick={() => {
            navigator.clipboard.writeText(redirectURL);
            successMessage("Redirect URI is copied to the clipboard");
          }}
        >
          <ContentCopyIcon
            sx={{
              color: "#000",
            }}
          />
        </Avatar>

      </Stack>
      <Stack sx={{
        flexDirection: "row",
        gap: "4px",
        alignItems: "center",
        padding: "6px 4px",
        mt: "-16px",
      }}>
        <img style={{
          height: "18px"
        }} alt="details" src="/icons/ic_info.svg" />
        <Typography variant="caption" lineHeight="15px" color="#666666">
          Please add this Redirect URI to your Tanda application settings. This URI is required for the OAuth authentication process.
          Please click <a href="https://my.tanda.co/api/oauth/applications" target="_blank" rel="noopener noreferrer" style={{ color: "#1976d2", textDecoration: "none" }}>here</a> to add the application from Tanda.
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="end" gap={2} mt="8px">
        <LoadingButton
          loading={state.isSaveButton}
          variant="contained"
          onClick={onSubmit}
        >
          Save & Connect
        </LoadingButton>
      </Stack>
    </Stack>
  );
};

export default ConnectTandaDialog;